import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Service de logging centralisé
 * Les logs de développement (log, warn) ne s'affichent qu'en mode développement
 * Les erreurs (error) s'affichent toujours
 */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  /**
   * Log d'information - uniquement en développement
   */
  log(...args: any[]): void {
    if (!environment.production) {
      console.log(...args);
    }
  }

  /**
   * Log de warning - uniquement en développement
   */
  warn(...args: any[]): void {
    if (!environment.production) {
      console.warn(...args);
    }
  }

  /**
   * Log d'erreur - toujours affiché
   */
  error(...args: any[]): void {
    console.error(...args);
  }

  /**
   * Log de debug - uniquement en développement
   */
  debug(...args: any[]): void {
    if (!environment.production) {
      console.debug(...args);
    }
  }

  /**
   * Log d'information avec préfixe - uniquement en développement
   */
  info(...args: any[]): void {
    if (!environment.production) {
      console.info(...args);
    }
  }

  /**
   * Groupe de logs - uniquement en développement
   */
  group(label: string): void {
    if (!environment.production) {
      console.group(label);
    }
  }

  /**
   * Fermer un groupe de logs - uniquement en développement
   */
  groupEnd(): void {
    if (!environment.production) {
      console.groupEnd();
    }
  }

  /**
   * Table de données - uniquement en développement
   */
  table(data: any): void {
    if (!environment.production) {
      console.table(data);
    }
  }
}

/**
 * Instance globale du logger pour utilisation standalone
 * Utilisez `logger.log()` au lieu de `console.log()` dans toute l'application
 */
export const logger = new LoggerService();
